module.exports = __webpack_public_path__ + "img/title.1e5f5952.png";